import React, { useState, useRef, useEffect } from "react";
import useClickOutside from "../../../../components/Custom_Hooks/useClickOutsSide";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  contraVoucherCreate,
  openModal,
} from "../../../../redux/actions/action-creator";
import { useInputActionVoucher } from "../../../../components/Custom_Hooks/useInputActionVoucher";
import InputField from "../../../../components/Input/InputField";
import DropdownLayout_1 from "../../../../components/Dropdown/DropdownLayout_1";
import Input from "../../../../components/Input/Input";
import {
  prepareFormData,
  useFormHandler,
} from "../../../../components/Custom_Hooks/useFormHandler";
import Form from "../../../../components/Form/Form";
import MasterCreationFooter from "../../../../components/Footer/Master_Footer/MasterCreationFooter";
import { toast } from "react-toastify";
import { VoucherSalesPurchaseInputRow } from "./VoucherSalesPurchaseInputRow";
import { currencyFormate } from "../../../../components/Date_Formate_Utilitiy/Index";
import { PaymentAllocation } from "./PaymentAllocation";
import Total_Amount_Row_Sell_Purchase from "../../../../components/Total_Amount/Total_Amount_Row_Sell_Purchase";
import TableHeaderSalePurchase from "../../../../components/Table/TableHeaderSalePurchase";
import OrderDetails from "../voucher_modal/OrderDetails";
import DispatchDetails from "../voucher_modal/DispatchDetails";
const array_avai_not_avai = [
  { id: 1, name: "Not Available" },
  { id: 2, name: "Available" },
];
const Purchase = ({
  data,
  setData,
  itemData,
  godownLocation,
  godownLocationItem,
  itemLedgerData,
  itemLedgerPurchaseData,
  party_bill_and_ship_to_ledger_list,
  sales_ledger_list,
  purchase_ledger_list,
  handleChange,
  handleBlur,
  handleFocus,
  handleKeyDown,
  handleKeyDownItem,
  handleItemUpdate,
  handleDynamicFocus,
  handleDynamicBlur,
  handleDropdownClick,
  handleDropdownDynamicClick,
  handleFocusReset,
  setSubmitConfirm,
  submitConfirm,
  inputRefs,
  dynamicInputRef,
  handleSubmit,
  loading,
  loading_voucher,
  modal_state,
  payment_allocation_ledger_list,
  dynamicInputRef_payment_allocation,
}) => {
  // Add useEffect to focus on create_date when component loads
  useEffect(() => {
    if (inputRefs?.create_date?.current) {
      setTimeout(() => {
        inputRefs.create_date.current.focus();
        if (inputRefs.create_date.current.value) {
          inputRefs.create_date.current.setSelectionRange(0, inputRefs.create_date.current.value.length);
        }
      }, 100);
    }
  }, [inputRefs?.create_date]);

  const inputFields = [
    {
      id: "1",
      label: "",
      name: "serial_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "2",
      label: "Date",
      name: "create_date",
      type: "text",
      isRequired: true,
    },
    {
      id: "3",
      label: "Supplier Inv/Ref NO",
      name: "supplier_ref_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "4",
      label: "Date",
      name: "date_payment",
      type: "text",
      isRequired: true,
    },
    {
      id: "5",
      label: "Party(Bill To)",
      name: "party_bill_to",
      type: "text",
      isRequired: true,
    },
    {
      id: "6",
      label: "Current Balance",
      name: "partry_bill_to_current_balance",
      type: "text",
      isRequired: true,
    },
    {
      id: "7",
      label: "Mailing Name",
      name: "party_bill_to_mailing_name",
      type: "text",
      isRequired: true,
    },
    {
      id: "8",
      label: "Address",
      name: "bill_to_address",
      type: "text",
      isRequired: true,
    },
    {
      id: "9",
      label: "Contact",
      name: "bill_to_contact",
      type: "text",
      isRequired: true,
    },
    {
      id: "10",
      label: "Party(Ship To)",
      name: "party_ship_to",
      type: "text",
      isRequired: true,
    },
    {
      id: "11",
      label: "Current Balance",
      name: "party_ship_to_current_balance",
      type: "text",
      isRequired: true,
    },
    {
      id: "12",
          label: "Mailing Name",
      name: "party_ship_to_mailing_name",
      type: "text",
      isRequired: true,
    },
    {
      id: "13",
      label: "Address",
      name: "ship_to_address",
      type: "text",
      isRequired: true,
    },
    {
      id: "14",
      label: "Contact",
      name: "ship_to_contact",
      type: "text",
      autoFocus: false,
      isRequired: true,
    },
    {
      id: "15",
      label: "Location",
      name: "location",
      type: "text", 
      isRequired: true,
    },
    {
      id: "16",
      label: "Purchase Ledger",
      name: "sale_purchase_ledger_account",
      type: "text",
      isRequired: true,
    },
    {
      id: "17",
      label: "Receipt Details",
      name: "dispatch_detail",
      type: "text",
      isRequired: true,
    },
    {
      id: "18",
      label: "Delivery Note No",
      name: "delivery_note_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "19",
      label: "Dispatch Doc No",
      name: "dispatch_doc_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "20",
      label: "Dispatch Through",
      name: "dispatch_through",
      type: "text",
      isRequired: true,
    },
    {
      id: "21",
      label: "Destination",
      name: "destination",
      type: "text",
      isRequired: true,
    },
    {
      id: "22",
      label: "Carrier Name/Agent",
      name: "carrier_name_agent",
      type: "text",
      isRequired: true,
    },
    {
      id: "23",
      label: "Bill of Loading",
      name: "bill_of_loading",
      type: "text",
      isRequired: true,
    },
    {
      id: "24",
      label: "Dispatch Date",
      name: "dispatch_date",
      type: "text",
      isRequired: true,
    },
    {
      id: "25",
      label: "Order Details",
      name: "order_detail",
      type: "text",
      isRequired: true,
    },
    {
      id: "26",
      label: "Order No",
      name: "order_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "27",
      label: "Mode of Term Payment",
      name: "mode_term_payment",
      type: "text",
      isRequired: true,
    },
    {
      id: "28",
      label: "Other Reference",
      name: "other_reference",
      type: "text",
      isRequired: true,
    },
    {
      id: "29",
      label: "Term of Delivery",
      name: "term_of_delivery",
      type: "text",
      isRequired: true,
    },
    {
      id: "30",
      label: "Narration",
      name: "narration",
      type: "text",
      isRequired: true,
    },
  ];

  const dropdownConfig = {
    party_bill_to: {
      title: "List of Ledger",
      input_id: "party_bill_to_ledger_id",
      data: party_bill_and_ship_to_ledger_list,
    },
    party_ship_to: {
      title: "List of Ledger",
      input_id: "party_ship_to_ledger_id",
      data: party_bill_and_ship_to_ledger_list,
    },
    location: {
      title: "List of Location",
      input_id: "location_id",
      data:godownLocation,
    },
    sale_purchase_ledger_account: {
      title: "List of Ledger",
      input_id: "sales_ledger_order_id",
      data: purchase_ledger_list,
    },
    dispatch_detail: { title: "Dispatch Details", data: array_avai_not_avai },
    order_detail: { title: "Order Details", data: array_avai_not_avai },
  };

  return (
    <Form
      handleSubmit={handleSubmit}
      handleKeyDown={handleKeyDown}
      submitConfirm={submitConfirm}
      handleFocusReset={handleFocusReset}
      title={"Accounting Voucher Creation"}
      loading={loading || loading_voucher}
      col="col-12"
      Footer={MasterCreationFooter}
    >

      {data?.dispatch_detail === "Available" && modal_state?.dispatch_detail_modal ? (
        <DispatchDetails
          data={data}
          setData={setData}
          inputFields={inputFields}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleFocus={handleFocus}
          inputRefs={inputRefs}
        />
      ) : null}
      {data?.order_detail === "Available" && modal_state?.order_detail_modal ? (
        <OrderDetails
          data={data}
          setData={setData}
          inputFields={inputFields}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleFocus={handleFocus}
          inputRefs={inputRefs}
        />
      ) : null}
      <div className="row p-0 m-0 mb-1">
        <div className="col-6">
          <div className="d-flex justify-content-between align-item-center">
            <label className="lab_voucher_entry" style={{ width: "75%" }}>
              {data?.voucher_type_name} No
            </label>
            <label>:</label>
            {inputFields
              .slice(0, 1)
              .map(
                (
                  { label, name, type, isRequired, isDisabled, autoFocus },
                  index
                ) => (
                  <input
                    style={{ fontSize: 13, fontWeight: "bold", width: "100%" }}
                    type={type}
                    disabled={true}
                    name={name}
                    id={name}
                    value={data[name] || ""}
                    onChange={handleChange}
                    onKeyUp={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                    autoFocus={autoFocus}
                  />
                )
              )}
          </div>
        </div>
        {inputFields
          .slice(1, 4)
          .map(({ label, name, type, isRequired, autoFocus }, index) => (
            <div className="col-6">
              {index === 0 ? (
                <div className="row justify-content-end">
                  <div className="col-6 d-flex justify-content-end">
                    {inputFields
                      .slice(1, 2)
                      .map(
                        (
                          { label, name, type, isRequired, autoFocus },
                          index
                        ) => (
                          <>
                          <label className="pe-2">{data?.day_name}</label>
                          <input
                            style={{
                              fontSize: 13,
                              textAlign: "right",
                              fontWeight: "bold",
                              width: "38%",
                              paddingRight: "2px",
                            }}
                            type={type}
                            name={name}
                            value={data[name] || ""}
                            onChange={handleChange}
                            onKeyUp={handleChange}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                            isRequired={isRequired}
                            ref={inputRefs[name]}
                            autoFocus={autoFocus}
                          />
                          </>
                        )
                      )}
                  </div>
                </div>
              ) : (
                <InputField
                  height="3vh"
                  key={index}
                  lable={label}
                  type={type}
                  name={name}
                  value={data[name] || ""}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  isRequired={isRequired}
                  ref={inputRefs[name]}
                />
              )}
            </div>
          ))}
      </div>

      <div className="row p-0 m-0 pb-1 mb-1">
        <div className="col-6">
          {inputFields
            .slice(4, 9)
            .map(({ label, name, type, isRequired, autoFocus }, index) => (
              <InputField
                height="3vh"
                key={index}
                lable={label}
                type={type}
                name={name}
                value={data[name] || ""}
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                isRequired={isRequired}
                ref={inputRefs[name]}
                autoFocus={autoFocus}
              />
            ))}

          {Object.entries(dropdownConfig).map(
            ([key, config]) =>
              modal_state?.[key] && key !== 'party_ship_to' && key !== 'dispatch_detail' && key !== 'order_detail' && (
                <DropdownLayout_1
                  key={key}
                  title={config.title}
                  state={modal_state[key]}
                  data={data}
                  setData={setData}
                  input_value={data[key]}
                  input_key={key}
                  input_id={config?.input_id}
                  rawData={config.data}
                  ref={inputRefs[key]}
                  inputRefs={inputRefs}
                  setSubmitConfirm={setSubmitConfirm}
                  handleDropdownClick={handleDropdownClick}
                />
              )
          )}
        </div>
        <div className="col-6">
          {inputFields
            .slice(9, 14)
            .map(({ label, name, type, isRequired }, index) => {
              if (name === "party_ship_to") {
                return (
                  <div className="row m-0 p-0 position-relative" style={{ height: "3vh" }}>
                    <div className={`col-5 m-0 p-0 text-start text-truncate`}>
                      <label>
                        {label}
                        {isRequired ? (
                          <span className="star_color">*</span>
                        ) : null}{" "}
                      </label>
                    </div>
                    <div className=" m-0 p-0" style={{ width: "2%" }}>
                      <label> :</label>
                    </div>
                    <div
                      className={`col-5 p-0 m-0 text-start`}
                      // style={{ position: "relative" }}
                    >
                      <input
                        style={{
                          fontSize: 13,
                          fontWeight: "bold",
                          width: "100%",
                        }}
                        type={type}
                        autoComplete="off"
                        disabled={false}
                        className={false ? "text-muted" : ""}
                        autoFocus={false}
                        name={name}
                        id={name}
                        value={data[name] || ""}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        ref={inputRefs[name]}
                      />
                    </div>
                    {Object.entries(dropdownConfig).map(
            ([key, config]) =>
              modal_state?.[key] &&
              key === "party_ship_to" && (
                <DropdownLayout_1
                   className="dropdown-content-list_custom"
                  key={key}
                  title={config.title}
                  state={modal_state[key]}
                  data={data}
                  setData={setData}
                  input_value={data[key]}
                  input_key={key}
                  input_id={config?.input_id}
                  rawData={config.data}
                  ref={inputRefs[key]}
                  inputRefs={inputRefs}
                  setSubmitConfirm={setSubmitConfirm}
                  handleDropdownClick={handleDropdownClick}
                />
              )
          )} 
                  </div>
                );
              } else {
                return (
                  <InputField
                    height="3vh"
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                );
              }
            })}
        </div>
      </div>
      <div className="row p-0 m-0 pb-1 mb-1" style={{ height: "3vh" }}>
        {inputFields
          .slice(14, 17)
          .map(({ label, name, type, isRequired }, index) => {
            if (name === "dispatch_detail") {
              return (
                <div className="col-3 position-relative" key={index}>
                  <InputField
                    height="3vh"
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                  {Object.entries(dropdownConfig).map(
                    ([key, config]) =>
                      modal_state?.[key] &&
                      key === "dispatch_detail" && (
                        <DropdownLayout_1
                          key={key}
                          className="dropdown-content-list_custom"
                          title={config.title}
                          state={modal_state[key]}
                          data={data}
                          setData={setData}
                          input_value={data[key]}
                          input_key={key}
                          input_id={config?.input_id}
                          rawData={config.data}
                          ref={inputRefs[key]}
                          inputRefs={inputRefs}
                          setSubmitConfirm={setSubmitConfirm}
                          handleDropdownClick={handleDropdownClick}
                        />
                      )
                  )}
                </div>
              );
            } else {
              return (
                <div className="col-3" key={index}>
                  <InputField
                    height="3vh"
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                </div>
              );
            }
          })}
        {inputFields
          .slice(24, 25)
          .map(({ label, name, type, isRequired }, index) => {
            if (name === "order_detail") {
              return (
                <div className="col-3 position-relative" key={index}>
                  <InputField
                    height="3vh"
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                  {Object.entries(dropdownConfig).map(
                    ([key, config]) =>
                      modal_state?.[key] &&
                      key === "order_detail" && (
                        <DropdownLayout_1
                          className="dropdown-content-list_custom"
                          key={key}
                          title={config.title}
                          state={modal_state[key]}
                          data={data}
                          setData={setData}
                          input_value={data[key]}
                          input_key={key}
                          input_id={config?.input_id}
                          rawData={config.data}
                          ref={inputRefs[key]}
                          inputRefs={inputRefs}
                          setSubmitConfirm={setSubmitConfirm}
                          handleDropdownClick={handleDropdownClick}
                        />
                      )
                  )}
                </div>
              );
            }
          })}
      </div>
      <TableHeaderSalePurchase data={data} />
      <VoucherSalesPurchaseInputRow
        data={data}
        setData={setData}
        itemData={ itemData }
        itemLedgerData={ itemLedgerPurchaseData }
        handleChange={handleItemUpdate}
        handleFocus={handleDynamicFocus}
        handleBlur={handleDynamicBlur}
        inputRefs={dynamicInputRef}
        handleDropdownDynamicClick={handleDropdownDynamicClick}
      />
      <Total_Amount_Row_Sell_Purchase data={data} />

      <div className="row p-0 pb-2 m-0" style={{ width: "100%" }}>
        <div className="col-6 m-0 p-0 ps-1 text-start">
          {inputFields
            .slice(29)
            .map(({ label, name, type, isRequired }, index) => (
              <>
                <label className="ps-2">{label} </label>
                <div className="d-flex justify-content-between align-item-center">
                  <textarea
                    style={{ height: "7.5vh" }}
                    key={index}
                    lable={label}
                    className="narration_input"
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    onKeyUp={handleChange}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                </div>
              </>
            ))}
        </div>
        <div className="col-6 m-0 p-0 ps-1 text-start">
         <label className='lab_voucher_entry'>Payment Allocation</label>
          <PaymentAllocation
            data={data}
            setData={setData}
            handleChange={handleItemUpdate}
            handleBlur={handleDynamicBlur}
            handleFocus={handleDynamicFocus}
            inputRefs={dynamicInputRef_payment_allocation}
            itemLedgerData={payment_allocation_ledger_list}
            handleDropdownDynamicClick={handleDropdownDynamicClick}
          />
          <div
            className="row justify-content-between border_2_1px_top border_2_1px_bottom"
            style={{ height: 25 }}
          >
            <div
              className={`col-4 m-0`}
            >
              <label className="font_size">{data?.party_bill_to}</label>
            </div>
            <div className={`col-2 m-0 p-0 container_of_voucher_dynamic_input`}>
              {data?.total_amount_allocate_party
                ? currencyFormate(data?.total_amount_allocate_party)
                : ""}
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default Purchase;
